import { isSentinelValue } from "@/lib/env";

/** Default landing route after sign-in (and `/` redirect). */
export const ADMIN_HOME_PATH = "/orgs";

export const customerAppUrl = (): string | undefined => {
  const value = process.env.NEXT_PUBLIC_CUSTOMER_APP_URL;
  if (!value || isSentinelValue(value)) {
    return undefined;
  }
  return value;
};

/** Absolute URL (or path) on the customer app origin. */
export const customerAppPath = (path: string): string => {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  const origin = customerAppUrl()?.replace(/\/$/, "");
  return origin ? `${origin}${normalized}` : normalized;
};
